/**
 * Export filename rule ported 1:1 from iOS.
 * iOS source of truth: WorkPDFCustomPage.generateDocumentName(coverTitle:)
 */
export function generateDocumentName(coverTitle: string, pageArtists: string[]): string {
	// if cover name provided use it as file name
	if (coverTitle !== "") {
		return coverTitle
	}

	// otherwise use the deduped list of artists from the selected pages
	const unique: string[] = []
	pageArtists.forEach((artist) => {
		if (!unique.includes(artist)) {
			unique.push(artist)
		}
	})

	const title = unique.length <= 2 ? unique.join(" ") : "Selected Artists"

	if (title.trim() !== "") {
		return title
	}

	// if there are no artists use default
	return "Views"
}
